// "use client"
// // Import necessary Material-UI components and hooks
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   useMediaQuery,
//   Button,
//   Stack,
// } from "@mui/material"
// // Import theme hook for responsive design
// import { useTheme } from "@mui/material/styles"
// // Import icons for buttons
// import DownloadIcon from "@mui/icons-material/Download"
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
// // Import context for user data
// import { useStateContext } from "../context/ContextProvider"
// // Import translation hook for internationalization
// import { useTranslation } from "react-i18next";

// // GDPRPolicy component: Displays the GDPR Privacy Policy and handles user agreement
// const GDPRPolicy = ({ onAgree, isModal = false, isSubmitting = false }) => {
//   // Access Material-UI theme
//   const theme = useTheme()
//   // Check if the screen is mobile-sized
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
//   // Access user data from context
//   const { user } = useStateContext()
//   // Translation hook for internationalization
//   const { t } = useTranslation();

//   // Function to trigger download of GDPR policy PDF
//   const handleDownloadPDF = () => {
//     // Create a link to the PDF file in the public folder
//     const link = document.createElement("a")
//     link.href = "/gdpr-policy.pdf" // Path to your PDF file in the public folder
//     link.download = "General Data Protection Regulation.pdf" // Name for the downloaded file
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//   }

//   // Placeholder function for GDPR agreement (to be implemented by user)
//   const handleAgree = () => {
//     // User will implement this functionality
//     console.log("User agreed to GDPR Policy")
//   }

//   return (
//     <Container maxWidth="lg" sx={{ py: 4 }}>
//       <Paper
//         elevation={3}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           overflow: "hidden",
//         }}
//       >
//         {/* Policy Title */}
//         <Typography variant="h4" component="h1" gutterBottom align="center" sx={{ mb: 3 }}>
//           {/* General Data Protection Regulation (GDPR) Privacy Policy */}
//             {t("GDPR Title")}
//         </Typography>

//         {/* Section 1: Introduction */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 1. Introduction */}
//              {t("GDPR Section 1 Title")}
//           </Typography>
//           <Typography paragraph>
//             At T.I Talostech Innovation Ltd, we recognize the importance of protecting your personal data. This Privacy
//             Policy outlines how we collect, use, store, and protect your personal data when you use our software,
//             Appointment System. We are committed to complying with the General Data Protection Regulation (GDPR)
//             (Regulation (EU) 2016/679) and ensuring that your privacy rights are respected and safeguarded.
//           </Typography>
//           <Typography paragraph>
//             The Appointment System is designed to facilitate the arrangement of medical appointments between patients
//             and doctors. We take all necessary measures to ensure that personal data is handled in a secure and lawful
//             manner. This Privacy Policy details how we collect and process personal data to provide our services, as
//             well as your rights under the GDPR.
//           </Typography>
//         </Box>

//         {/* Section 2: Personal Data We Collect */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 2. Personal Data We Collect */}
//               {t("GDPR Section 2 Title")}
//           </Typography>
//           <Typography paragraph>
//             We collect personal data that is necessary to deliver our appointment scheduling services. The following
//             types of personal data may be collected and processed:
//           </Typography>

//           {/* Required Personal Data */}
//           <Box sx={{ ml: 2, mb: 2 }}>
//             <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
//               Required Personal Data:
//             </Typography>
//             <List dense disablePadding>
//               <ListItem>
//                 <ListItemText primary="• Name" />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="• Surname" />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="• Email Address" />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="• Phone Number" />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="• Gender (Optional)" />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="• Date of Birth Age (Optional)" />
//               </ListItem>
//             </List>
//           </Box>

//           {/* Optional Data No Longer Collected */}
//           {/* <Box sx={{ ml: 2, mb: 2 }}>
//             <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
//               Optional Data Removed (Not Collected Anymore):
//             </Typography>
//             <List dense disablePadding>
//               <ListItem>
//                 <ListItemText primary="• Address" />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="• Postal Code" />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="• City" />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary="• ID Number" />
//               </ListItem>
//             </List>
//           </Box> */}

//           <Typography paragraph>
//             This data is primarily provided by the doctor or the doctor's secretary, and is used exclusively for
//             managing appointments, notifications, and providing analytics. We do not collect sensitive personal health
//             data such as medical history, insurance details, or diagnoses.
//           </Typography>
//         </Box>

//         {/* Section 3: Purpose of Data Collection */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 3. Purpose of Data Collection */}
//               {t("GDPR Section 3 Title")}
//           </Typography>
//           <Typography paragraph>
//             The primary purpose of collecting personal data is to provide our appointment management services and to
//             communicate with patients and doctors effectively. We process personal data for the following reasons:
//           </Typography>

//           <Box sx={{ ml: 2, mb: 2 }}>
//             <Typography paragraph>
//               <strong>• Appointment Scheduling:</strong> The software enables doctors and patients to schedule, manage,
//               and confirm appointments.
//             </Typography>
//             <Typography paragraph>
//               <strong>• Notification Services:</strong> We use email and phone numbers to send appointment
//               confirmations, reminders, and other notifications relevant to patients' appointments.
//             </Typography>
//             <Typography paragraph>
//               <strong>• Data Analytics:</strong> We analyze the collected data (age and gender) to help doctors and the
//               system administrators gain insights into usage patterns and improve the system.
//             </Typography>
//           </Box>

//           <Typography paragraph>
//             We do not use personal data for marketing, advertising, or any other purposes outside of the primary
//             services provided by the software.
//           </Typography>
//         </Box>

//         {/* Section 4: Data Storage and Security Measures */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 4. Data Storage and Security Measures */}
//               {t("GDPR Section 4 Title")}
//           </Typography>
//           <Typography paragraph>
//             We take data security seriously and use industry-standard security measures to protect personal data. The
//             data we collect is securely stored on cloud-based servers that are located in Europe.
//           </Typography>

//           {/* Hosting Providers */}
//           <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
//             Hosting Providers and Locations:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• Contabo VPS (Europe)" />
//             </ListItem>
//             <ListItem>
//             {/* <ListItemText primary="• Velia (France, EU)" /> */}
//             </ListItem> 
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             These hosting providers ensure that all data remains in the EU, complying with GDPR regulations. We also
//             ensure that all third-party service providers comply with GDPR and that your personal data is treated with
//             the highest level of security.
//           </Typography>

//           {/* Data Storage Details */}
//           <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
//             How Data is Stored:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• All personal data is stored on a cloud-based server." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• The data is entered into the system by the doctor or the doctor's secretary." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• Patients cannot directly input or modify their own data within the software." />
//             </ListItem>
//           </List>

//           {/* Security Measures */}
//           <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
//             Data Protection Measures:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Encryption:"
//                 secondary="All data stored in our system, including databases and hard drives, is encrypted to prevent unauthorized access."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Access Control:"
//                 secondary="Only authorized personnel can access the server, and the server itself is only accessible from our office for maintenance purposes."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• SSL Encryption:"
//                 secondary="We use Secure Socket Layer (SSL) encryption for all data transmissions, ensuring that data is securely transmitted between the user and the server."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Authentication:"
//                 secondary="We require users (doctors and secretaries) to log in with username and password credentials to access the system."
//               />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 5: Sharing Personal Data with Third Parties */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 5. Sharing Personal Data with Third Parties */}
//               {t("GDPR Section 5 Title")}
//           </Typography>
//           <Typography paragraph>
//             We do not sell or share personal data with third parties for marketing purposes. However, we do share
//             personal data with certain trusted third-party service providers in order to operate the software and
//             provide essential services. These include:
//           </Typography>

//           {/* Third-Party Providers Table */}
//           <TableContainer component={Paper} sx={{ mb: 2 }}>
//             <Table size={isMobile ? "small" : "medium"}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>
//                     <strong>Third-Party Provider</strong>
//                   </TableCell>
//                   <TableCell>
//                     <strong>Purpose of Data Sharing</strong>
//                   </TableCell>
//                   <TableCell>
//                     <strong>Location</strong>
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 <TableRow>
//                   {/* <TableCell>Velia.net Internetdienste GmbH</TableCell>
//                   <TableCell>Cloud Hosting Services</TableCell>
//                   <TableCell>Germany</TableCell> */}
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Contabo GmbH</TableCell>
//                   <TableCell>Cloud Hosting Services</TableCell>
//                   <TableCell>Germany</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Cytacom Solutions Ltd</TableCell>
//                   <TableCell>SMS Notification Service</TableCell>
//                   <TableCell>Cyprus</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Databasemart LLC</TableCell>
//                   <TableCell>Email Notification Service</TableCell>
//                   <TableCell>USA</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <Typography paragraph>
//             We ensure that all third-party providers comply with GDPR and that any data shared with them is handled
//             securely and lawfully. All third-party providers are contractually obligated to maintain the confidentiality
//             of your data.
//           </Typography>
//         </Box>

//         {/* Section 6: User Rights Under GDPR */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 6. User Rights Under GDPR */}
//               {t("GDPR Section 6 Title")}
//           </Typography>
//           <Typography paragraph>
//             As a user, you have various rights regarding your personal data under the GDPR. These rights include:
//           </Typography>

//           <List dense sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="1. Right to Access:"
//                 secondary="You have the right to request access to your personal data that we hold."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="2. Right to Rectification:"
//                 secondary="You can request correction of any inaccurate or incomplete data we have about you."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="3. Right to Erasure (Right to be Forgotten):"
//                 secondary="You can request that we delete your personal data under certain conditions."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="4. Right to Restriction of Processing:"
//                 secondary="You can ask us to restrict the processing of your data in certain situations."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="5. Right to Data Portability:"
//                 secondary="You can request a copy of your personal data in a structured, commonly used format, which you can transfer to another service."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="6. Right to Object:"
//                 secondary="You can object to our processing of your personal data for certain purposes, including data processing that is based on legitimate interests or is for direct marketing purposes."
//               />
//             </ListItem>
//           </List>

//           {/* Exercising Rights */}
//           <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
//             Exercising Your Rights:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• Currently, patients cannot directly modify or delete their personal data through the software." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• If you wish to exercise your rights (e.g., access, rectification, or deletion of your data), please contact us at [Insert Contact Information]. We will respond to your request within the timeframe specified by the GDPR." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• Additionally, we offer a GDPR Report feature within the software, allowing doctors or their secretaries to generate a PDF report detailing the data stored about a patient. This report can be provided to patients upon their request." />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 7: Data Retention */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 7. Data Retention */}
//               {t("GDPR Section 7 Title")}
//           </Typography>
//           <Typography paragraph>
//             We retain personal data as long as it is necessary to provide our services and comply with legal
//             obligations.
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Data Retention Period:"
//                 secondary="We do not currently have an automatic system in place for deleting or anonymizing data. The data is kept until the patient no longer requires appointments with the doctor."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Patient Data:"
//                 secondary="If patients request the deletion of their data, we will comply within the limits of applicable law."
//               />
//             </ListItem>
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             We are reviewing our data retention policy to ensure compliance with GDPR guidelines and to implement
//             automatic data deletion or anonymization procedures where necessary.
//           </Typography>
//         </Box>

//         {/* Section 8: Legal Basis for Data Processing */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 8. Legal Basis for Data Processing */}
//               {t("GDPR Section 8 Title")}
//           </Typography>
//           <Typography paragraph>
//             Under the GDPR, we must have a legal basis to collect and process your personal data. Currently, the data is
//             entered into the software by the doctor or the doctor's secretary, and we are assessing the most appropriate
//             legal basis for processing this data. Possible legal bases include:
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• User Consent:"
//                 secondary="If we require consent to collect data, we will implement a consent mechanism within the software."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Contractual Necessity:"
//                 secondary="The processing of personal data may be necessary to provide the appointment scheduling services that the patient has requested."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Legal Obligation:"
//                 secondary="We may be required to process certain data to comply with legal obligations related to healthcare."
//               />
//             </ListItem>
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             We are evaluating the need for written consent from patients for data processing and will implement such
//             consent mechanisms in the future if necessary.
//           </Typography>
//         </Box>

//         {/* Section 9: Cookies and Tracking Technologies */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 9. Cookies and Tracking Technologies */}
//               {t("GDPR Section 9 Title")}
//           </Typography>
//           <Typography paragraph>
//             The Appointment System does not use cookies or any tracking technologies for user behavior analysis or
//             advertising purposes. The software is operated on a subscription model for doctors, and we do not track or
//             monitor users' activities beyond the appointment scheduling functionality.
//           </Typography>
//         </Box>

//         {/* Section 10: Data Transfers Outside the EU */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 10. Data Transfers Outside the EU */}
//               {t("GDPR Section 10 Title")}
//           </Typography>
//           <Typography paragraph>
//             We ensure that all personal data is stored within the European Union (EU). However, some of our third-party
//             providers, such as Databasemart LLC (USA), may process personal data outside the EU. We ensure that all
//             third-party service providers comply with GDPR requirements by using appropriate safeguards, such as:
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Standard Contractual Clauses (SCCs):"
//                 secondary="We enter into contracts with our service providers to ensure that they comply with GDPR requirements for data transfers outside the EU."
//               />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 11: GDPR Report Feature */}
//         <Box sx={{ mb: 4 }}>
          
//              <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//                       {/* 1. Introduction */}
//                       {t("GDPR Section 1 Title")}
//                     </Typography>
//                     <Typography paragraph>
//                       {t("GDPR Section 1 Intro P1")}
//                     </Typography>
//                     <Typography paragraph>
//                       {t("GDPR Section 1 Intro P2")}
//                     </Typography>
            
//         </Box>

//         {/* Section 12: Contact Information */}
//         <Box sx={{ mb: 2 }}>
//           <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//             {/* 12. Contact Information */}
//               {t("GDPR Section 12 Title")}
//           </Typography>
//           <Typography paragraph>
//             For any questions, concerns, or requests regarding this Privacy Policy or your personal data, please contact
//             us at:
//           </Typography>

//           <Box sx={{ ml: 2 }}>
//             <Typography paragraph>
//               T.I Talostech Innovation Ltd
//               {/* <br />
//               BBBBBB */}
//               <br />
//               Email: support@ti-talostech.com
//               <br />
//               {/* Phone: +357912121212 */}
//             </Typography>
//           </Box>
//         </Box>

//         {/* Page Indicator */}
//         <Divider sx={{ my: 3 }} />
//         <Typography variant="body2" color="text.secondary" align="center">
//           GDPR Privacy Policy | Last Updated: {new Date().toLocaleDateString()}
//         </Typography>

//         {/* Action Buttons */}
//         <Stack direction={isMobile ? "column" : "row"} spacing={2} sx={{ mt: 4 }} justifyContent="center">
//           {/* Download PDF Button (Hidden in Modal View) */}
//           {!isModal && (
//             <Button
//               variant="outlined"
//               color="primary"
//               startIcon={<DownloadIcon />}
//               onClick={handleDownloadPDF}
//               sx={{ minWidth: 200 }}
//             >
//               {t('Download PDF')}
//             </Button>
//           )}
//           {/* Agree Button for Clients (Visible if GDPR Not Accepted) */}
//           {user?.user_role === "CLIENT" && !user?.gdpr_accepted && (
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={<CheckCircleOutlineIcon />}
//               onClick={isModal ? onAgree : handleAgree}
//               disabled={isSubmitting}
//               sx={{ minWidth: 200 }}
//             >
//               {isSubmitting ? t('Submitting...') : t('I Agree with GDPR Policy')}
//             </Button>
//           )}
//           {/* Disabled Button for Clients Who Have Accepted GDPR */}
//           {user?.user_role === "CLIENT" && user?.gdpr_accepted && (
//             <Button variant="contained" color="success" disabled sx={{ minWidth: 200 }}>
//               {t('GDPR Accepted')}
//             </Button>
//           )}
//         </Stack>
//       </Paper>
//     </Container>
//   )
// }

// export default GDPRPolicy



// "use client"
// // Import necessary Material-UI components and hooks
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   useMediaQuery,
//   Button,
//   Stack,
// } from "@mui/material"
// // Import theme hook for responsive design
// import { useTheme } from "@mui/material/styles"
// // Import icons for buttons
// import DownloadIcon from "@mui/icons-material/Download"
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
// // Import context for user data
// import { useStateContext } from "../context/ContextProvider"
// // Import translation hook for internationalization
// import { useTranslation } from "react-i18next"

// // GDPRPolicy component: Displays the GDPR Privacy Policy and handles user agreement
// const GDPRPolicy = ({ onAgree, isModal = false, isSubmitting = false }) => {
//   // Access Material-UI theme
//   const theme = useTheme()
//   // Check if the screen is mobile-sized
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
//   // Access user data from context
//   const { user } = useStateContext()
//   // Translation hook for internationalization
//   const { t } = useTranslation()

//   // Function to trigger download of GDPR policy PDF
//   const handleDownloadPDF = () => {
//     // Create a link to the PDF file in the public folder
//     const link = document.createElement("a")
//     link.href = "/gdpr-policy.pdf" // Path to your PDF file in the public folder
//     link.download = "General Data Protection Regulation.pdf" // Name for the downloaded file
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//   }

//   // Placeholder function for GDPR agreement (to be implemented by user)
//   const handleAgree = () => {
//     // User will implement this functionality
//     console.log("User agreed to GDPR Policy")
//   }

//   return (
//     <Container maxWidth="lg" sx={{ py: 4 }}>
//       <Paper
//         elevation={3}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           overflow: "hidden",
//         }}
//       >
//         {/* Policy Title */}
//         <Typography
//           variant="h4"
//           component="h1"
//           gutterBottom
//           align="center"
//           sx={{ mb: 3 }}
//         >
//           {t("GDPR Title")}
//         </Typography>

//         {/* Section 1: Introduction */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 1 Title")}
//           </Typography>
//           <Typography paragraph>
//             {t("GDPR Section 1 Intro P1")}
//           </Typography>
//           <Typography paragraph>
//             {t("GDPR Section 1 Intro P2")}
//           </Typography>
//         </Box>

//         {/* Section 2: Personal Data We Collect */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 2 Title")}
//           </Typography>
//           <Typography paragraph>
//             {t("GDPR Section 2 Intro")}
//           </Typography>

//           {/* Required Personal Data */}
//           <Box sx={{ ml: 2, mb: 2 }}>
//             <Typography
//               variant="subtitle1"
//               sx={{ fontWeight: "bold" }}
//             >
//               {t("GDPR Required Personal Data")}
//             </Typography>
//             <List dense disablePadding>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Name")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Surname")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Email")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Phone")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Gender Optional")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field DOB Optional")}`} />
//               </ListItem>
//             </List>
//           </Box>

//           <Typography paragraph>
//             {t("GDPR Section 2 Outro")}
//           </Typography>
//         </Box>

//         {/* Section 3: Purpose of Data Collection */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 3 Title")}
//           </Typography>
//           <Typography paragraph>
//             The primary purpose of collecting personal data is to provide our
//             appointment management services and to communicate with patients
//             and doctors effectively. We process personal data for the following
//             reasons:
//           </Typography>

//           <Box sx={{ ml: 2, mb: 2 }}>
//             <Typography paragraph>
//               <strong>• Appointment Scheduling:</strong> The software enables
//               doctors and patients to schedule, manage, and confirm appointments.
//             </Typography>
//             <Typography paragraph>
//               <strong>• Notification Services:</strong> We use email and phone
//               numbers to send appointment confirmations, reminders, and other
//               notifications relevant to patients&apos; appointments.
//             </Typography>
//             <Typography paragraph>
//               <strong>• Data Analytics:</strong> We analyze the collected data
//               (age and gender) to help doctors and the system administrators
//               gain insights into usage patterns and improve the system.
//             </Typography>
//           </Box>

//           <Typography paragraph>
//             We do not use personal data for marketing, advertising, or any other
//             purposes outside of the primary services provided by the software.
//           </Typography>
//         </Box>

//         {/* Section 4: Data Storage and Security Measures */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 4 Title")}
//           </Typography>
//           <Typography paragraph>
//             We take data security seriously and use industry-standard security
//             measures to protect personal data. The data we collect is securely
//             stored on cloud-based servers that are located in Europe.
//           </Typography>

//           {/* Hosting Providers */}
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: "bold", mt: 2 }}
//           >
//             Hosting Providers and Locations:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• Contabo VPS (Europe)" />
//             </ListItem>
//             <ListItem>
//               {/* <ListItemText primary="• Velia (France, EU)" /> */}
//             </ListItem>
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             These hosting providers ensure that all data remains in the EU,
//             complying with GDPR regulations. We also ensure that all third-party
//             service providers comply with GDPR and that your personal data is
//             treated with the highest level of security.
//           </Typography>

//           {/* Data Storage Details */}
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: "bold", mt: 2 }}
//           >
//             How Data is Stored:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• All personal data is stored on a cloud-based server." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• The data is entered into the system by the doctor or the doctor's secretary." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• Patients cannot directly input or modify their own data within the software." />
//             </ListItem>
//           </List>

//           {/* Security Measures */}
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: "bold", mt: 2 }}
//           >
//             Data Protection Measures:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Encryption:"
//                 secondary="All data stored in our system, including databases and hard drives, is encrypted to prevent unauthorized access."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Access Control:"
//                 secondary="Only authorized personnel can access the server, and the server itself is only accessible from our office for maintenance purposes."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• SSL Encryption:"
//                 secondary="We use Secure Socket Layer (SSL) encryption for all data transmissions, ensuring that data is securely transmitted between the user and the server."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Authentication:"
//                 secondary="We require users (doctors and secretaries) to log in with username and password credentials to access the system."
//               />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 5: Sharing Personal Data with Third Parties */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 5 Title")}
//           </Typography>
//           <Typography paragraph>
//             We do not sell or share personal data with third parties for
//             marketing purposes. However, we do share personal data with certain
//             trusted third-party service providers in order to operate the
//             software and provide essential services. These include:
//           </Typography>

//           {/* Third-Party Providers Table */}
//           <TableContainer component={Paper} sx={{ mb: 2 }}>
//             <Table size={isMobile ? "small" : "medium"}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>
//                     <strong>Third-Party Provider</strong>
//                   </TableCell>
//                   <TableCell>
//                     <strong>Purpose of Data Sharing</strong>
//                   </TableCell>
//                   <TableCell>
//                     <strong>Location</strong>
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 <TableRow>
//                   {/* <TableCell>Velia.net Internetdienste GmbH</TableCell>
//                   <TableCell>Cloud Hosting Services</TableCell>
//                   <TableCell>Germany</TableCell> */}
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Contabo GmbH</TableCell>
//                   <TableCell>Cloud Hosting Services</TableCell>
//                   <TableCell>Germany</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Cytacom Solutions Ltd</TableCell>
//                   <TableCell>SMS Notification Service</TableCell>
//                   <TableCell>Cyprus</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Databasemart LLC</TableCell>
//                   <TableCell>Email Notification Service</TableCell>
//                   <TableCell>USA</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <Typography paragraph>
//             We ensure that all third-party providers comply with GDPR and that
//             any data shared with them is handled securely and lawfully. All
//             third-party providers are contractually obligated to maintain the
//             confidentiality of your data.
//           </Typography>
//         </Box>

//         {/* Section 6: User Rights Under GDPR */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 6 Title")}
//           </Typography>
//           <Typography paragraph>
//             As a user, you have various rights regarding your personal data
//             under the GDPR. These rights include:
//           </Typography>

//           <List dense sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="1. Right to Access:"
//                 secondary="You have the right to request access to your personal data that we hold."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="2. Right to Rectification:"
//                 secondary="You can request correction of any inaccurate or incomplete data we have about you."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="3. Right to Erasure (Right to be Forgotten):"
//                 secondary="You can request that we delete your personal data under certain conditions."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="4. Right to Restriction of Processing:"
//                 secondary="You can ask us to restrict the processing of your data in certain situations."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="5. Right to Data Portability:"
//                 secondary="You can request a copy of your personal data in a structured, commonly used format, which you can transfer to another service."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="6. Right to Object:"
//                 secondary="You can object to our processing of your personal data for certain purposes, including data processing that is based on legitimate interests or is for direct marketing purposes."
//               />
//             </ListItem>
//           </List>

//           {/* Exercising Rights */}
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: "bold", mt: 2 }}
//           >
//             Exercising Your Rights:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• Currently, patients cannot directly modify or delete their personal data through the software." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• If you wish to exercise your rights (e.g., access, rectification, or deletion of your data), please contact us at [Insert Contact Information]. We will respond to your request within the timeframe specified by the GDPR." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• Additionally, we offer a GDPR Report feature within the software, allowing doctors or their secretaries to generate a PDF report detailing the data stored about a patient. This report can be provided to patients upon their request." />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 7: Data Retention */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 7 Title")}
//           </Typography>
//           <Typography paragraph>
//             We retain personal data as long as it is necessary to provide our
//             services and comply with legal obligations.
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Data Retention Period:"
//                 secondary="We do not currently have an automatic system in place for deleting or anonymizing data. The data is kept until the patient no longer requires appointments with the doctor."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Patient Data:"
//                 secondary="If patients request the deletion of their data, we will comply within the limits of applicable law."
//               />
//             </ListItem>
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             We are reviewing our data retention policy to ensure compliance with
//             GDPR guidelines and to implement automatic data deletion or
//             anonymization procedures where necessary.
//           </Typography>
//         </Box>

//         {/* Section 8: Legal Basis for Data Processing */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 8 Title")}
//           </Typography>
//           <Typography paragraph>
//             Under the GDPR, we must have a legal basis to collect and process
//             your personal data. Currently, the data is entered into the software
//             by the doctor or the doctor&apos;s secretary, and we are assessing
//             the most appropriate legal basis for processing this data. Possible
//             legal bases include:
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• User Consent:"
//                 secondary="If we require consent to collect data, we will implement a consent mechanism within the software."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Contractual Necessity:"
//                 secondary="The processing of personal data may be necessary to provide the appointment scheduling services that the patient has requested."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Legal Obligation:"
//                 secondary="We may be required to process certain data to comply with legal obligations related to healthcare."
//               />
//             </ListItem>
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             We are evaluating the need for written consent from patients for
//             data processing and will implement such consent mechanisms in the
//             future if necessary.
//           </Typography>
//         </Box>

//         {/* Section 9: Cookies and Tracking Technologies */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 9 Title")}
//           </Typography>
//           <Typography paragraph>
//             The Appointment System does not use cookies or any tracking
//             technologies for user behavior analysis or advertising purposes. The
//             software is operated on a subscription model for doctors, and we do
//             not track or monitor users&apos; activities beyond the appointment
//             scheduling functionality.
//           </Typography>
//         </Box>

//         {/* Section 10: Data Transfers Outside the EU */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 10 Title")}
//           </Typography>
//           <Typography paragraph>
//             We ensure that all personal data is stored within the European Union
//             (EU). However, some of our third-party providers, such as
//             Databasemart LLC (USA), may process personal data outside the EU. We
//             ensure that all third-party service providers comply with GDPR
//             requirements by using appropriate safeguards, such as:
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Standard Contractual Clauses (SCCs):"
//                 secondary="We enter into contracts with our service providers to ensure that they comply with GDPR requirements for data transfers outside the EU."
//               />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 11: GDPR Report Feature */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 11 Title")}
//           </Typography>
//           <Typography paragraph>
//             As part of our commitment to GDPR compliance and transparency, we
//             have implemented a GDPR Report feature within the Appointment
//             System. This feature enables doctors or their secretaries to
//             generate a detailed PDF report containing the personal data that is
//             stored for each patient. This report can be provided to the patient
//             upon request, ensuring that patients can access and review the data
//             we hold about them.
//           </Typography>
//         </Box>

//         {/* Section 12: Contact Information */}
//         <Box sx={{ mb: 2 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 12 Title")}
//           </Typography>
//           <Typography paragraph>
//             For any questions, concerns, or requests regarding this Privacy
//             Policy or your personal data, please contact us at:
//           </Typography>

//           <Box sx={{ ml: 2 }}>
//             <Typography paragraph>
//               T.I Talostech Innovation Ltd
//               <br />
//               Email: support@ti-talostech.com
//               <br />
//             </Typography>
//           </Box>
//         </Box>

//         {/* Page Indicator */}
//         <Divider sx={{ my: 3 }} />
//         <Typography
//           variant="body2"
//           color="text.secondary"
//           align="center"
//         >
//           GDPR Privacy Policy | Last Updated:{" "}
//           {new Date().toLocaleDateString()}
//         </Typography>

//         {/* Action Buttons */}
//         <Stack
//           direction={isMobile ? "column" : "row"}
//           spacing={2}
//           sx={{ mt: 4 }}
//           justifyContent="center"
//         >
//           {/* Download PDF Button (Hidden in Modal View) */}
//           {!isModal && (
//             <Button
//               variant="outlined"
//               color="primary"
//               startIcon={<DownloadIcon />}
//               onClick={handleDownloadPDF}
//               sx={{ minWidth: 200 }}
//             >
//               {t("Download PDF")}
//             </Button>
//           )}
//           {/* Agree Button for Clients (Visible if GDPR Not Accepted) */}
//           {user?.user_role === "CLIENT" && !user?.gdpr_accepted && (
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={<CheckCircleOutlineIcon />}
//               onClick={isModal ? onAgree : handleAgree}
//               disabled={isSubmitting}
//               sx={{ minWidth: 200 }}
//             >
//               {isSubmitting
//                 ? t("Submitting...")
//                 : t("I Agree with GDPR Policy")}
//             </Button>
//           )}
//           {/* Disabled Button for Clients Who Have Accepted GDPR */}
//           {user?.user_role === "CLIENT" && user?.gdpr_accepted && (
//             <Button
//               variant="contained"
//               color="success"
//               disabled
//               sx={{ minWidth: 200 }}
//             >
//               {t("GDPR Accepted")}
//             </Button>
//           )}
//         </Stack>
//       </Paper>
//     </Container>
//   )
// }

// export default GDPRPolicy

// "use client"
// // Import necessary Material-UI components and hooks
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   useMediaQuery,
//   Button,
//   Stack,
// } from "@mui/material"
// // Import theme hook for responsive design
// import { useTheme } from "@mui/material/styles"
// // Import icons for buttons
// import DownloadIcon from "@mui/icons-material/Download"
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline"
// // Import context for user data
// import { useStateContext } from "../context/ContextProvider"
// // Import translation hook for internationalization
// import { useTranslation } from "react-i18next"

// // GDPRPolicy component: Displays the GDPR Privacy Policy and handles user agreement
// const GDPRPolicy = ({ onAgree, isModal = false, isSubmitting = false }) => {
//   // Access Material-UI theme
//   const theme = useTheme()
//   // Check if the screen is mobile-sized
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"))
//   // Access user data from context
//   const { user } = useStateContext()
//   // Translation hook for internationalization
//   const { t } = useTranslation()

//   // Function to trigger download of GDPR policy PDF
//   const handleDownloadPDF = () => {
//     // Create a link to the PDF file in the public folder
//     const link = document.createElement("a")
//     link.href = "/gdpr-policy.pdf" // Path to your PDF file in the public folder
//     link.download = "General Data Protection Regulation.pdf" // Name for the downloaded file
//     document.body.appendChild(link)
//     link.click()
//     document.body.removeChild(link)
//   }

//   // Placeholder function for GDPR agreement (to be implemented by user)
//   const handleAgree = () => {
//     // User will implement this functionality
//     console.log("User agreed to GDPR Policy")
//   }

//   return (
//     <Container maxWidth="lg" sx={{ py: 4 }}>
//       <Paper
//         elevation={3}
//         sx={{
//           p: isMobile ? 2 : 4,
//           borderRadius: 2,
//           overflow: "hidden",
//         }}
//       >
//         {/* Policy Title */}
//         <Typography
//           variant="h4"
//           component="h1"
//           gutterBottom
//           align="center"
//           sx={{ mb: 3 }}
//         >
//           {t("GDPR Title")}
//         </Typography>

//         {/* Section 1: Introduction */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 1 Title")}
//           </Typography>
//           <Typography paragraph>
//             {t("GDPR Section 1 Intro P1")}
//           </Typography>
//           <Typography paragraph>
//             {t("GDPR Section 1 Intro P2")}
//           </Typography>
//         </Box>

//         {/* Section 2: Personal Data We Collect */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 2 Title")}
//           </Typography>
//           <Typography paragraph>
//             {t("GDPR Section 2 Intro")}
//           </Typography>

//           {/* Required Personal Data */}
//           <Box sx={{ ml: 2, mb: 2 }}>
//             <Typography
//               variant="subtitle1"
//               sx={{ fontWeight: "bold" }}
//             >
//               {t("GDPR Required Personal Data")}
//             </Typography>
//             <List dense disablePadding>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Name")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Surname")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Email")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Phone")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field Gender Optional")}`} />
//               </ListItem>
//               <ListItem>
//                 <ListItemText primary={`• ${t("GDPR Field DOB Optional")}`} />
//               </ListItem>
//             </List>
//           </Box>

//           <Typography paragraph>
//             {t("GDPR Section 2 Outro")}
//           </Typography>
//         </Box>

//         {/* Section 3: Purpose of Data Collection */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 3 Title")}
//           </Typography>
//           <Typography paragraph>
//             The primary purpose of collecting personal data is to provide our
//             appointment management services and to communicate with patients
//             and doctors effectively. We process personal data for the following
//             reasons:
//           </Typography>

//           <Box sx={{ ml: 2, mb: 2 }}>
//             <Typography paragraph>
//               <strong>• Appointment Scheduling:</strong> The software enables
//               doctors and patients to schedule, manage, and confirm appointments.
//             </Typography>
//             <Typography paragraph>
//               <strong>• Notification Services:</strong> We use email and phone
//               numbers to send appointment confirmations, reminders, and other
//               notifications relevant to patients&apos; appointments.
//             </Typography>
//             <Typography paragraph>
//               <strong>• Data Analytics:</strong> We analyze the collected data
//               (age and gender) to help doctors and the system administrators
//               gain insights into usage patterns and improve the system.
//             </Typography>
//           </Box>

//           <Typography paragraph>
//             We do not use personal data for marketing, advertising, or any other
//             purposes outside of the primary services provided by the software.
//           </Typography>
//         </Box>

//         {/* Section 4: Data Storage and Security Measures */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 4 Title")}
//           </Typography>
//           <Typography paragraph>
//             We take data security seriously and use industry-standard security
//             measures to protect personal data. The data we collect is securely
//             stored on cloud-based servers that are located in Europe.
//           </Typography>

//           {/* Hosting Providers */}
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: "bold", mt: 2 }}
//           >
//             Hosting Providers and Locations:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• Contabo VPS (Europe)" />
//             </ListItem>
//             <ListItem>
//               {/* <ListItemText primary="• Velia (France, EU)" /> */}
//             </ListItem>
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             These hosting providers ensure that all data remains in the EU,
//             complying with GDPR regulations. We also ensure that all third-party
//             service providers comply with GDPR and that your personal data is
//             treated with the highest level of security.
//           </Typography>

//           {/* Data Storage Details */}
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: "bold", mt: 2 }}
//           >
//             How Data is Stored:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• All personal data is stored on a cloud-based server." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• The data is entered into the system by the doctor or the doctor's secretary." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• Patients cannot directly input or modify their own data within the software." />
//             </ListItem>
//           </List>

//           {/* Security Measures */}
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: "bold", mt: 2 }}
//           >
//             Data Protection Measures:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Encryption:"
//                 secondary="All data stored in our system, including databases and hard drives, is encrypted to prevent unauthorized access."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Access Control:"
//                 secondary="Only authorized personnel can access the server, and the server itself is only accessible from our office for maintenance purposes."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• SSL Encryption:"
//                 secondary="We use Secure Socket Layer (SSL) encryption for all data transmissions, ensuring that data is securely transmitted between the user and the server."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Authentication:"
//                 secondary="We require users (doctors and secretaries) to log in with username and password credentials to access the system."
//               />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 5: Sharing Personal Data with Third Parties */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 5 Title")}
//           </Typography>
//           <Typography paragraph>
//             We do not sell or share personal data with third parties for
//             marketing purposes. However, we do share personal data with certain
//             trusted third-party service providers in order to operate the
//             software and provide essential services. These include:
//           </Typography>

//           {/* Third-Party Providers Table */}
//           <TableContainer component={Paper} sx={{ mb: 2 }}>
//             <Table size={isMobile ? "small" : "medium"}>
//               <TableHead>
//                 <TableRow>
//                   <TableCell>
//                     <strong>Third-Party Provider</strong>
//                   </TableCell>
//                   <TableCell>
//                     <strong>Purpose of Data Sharing</strong>
//                   </TableCell>
//                   <TableCell>
//                     <strong>Location</strong>
//                   </TableCell>
//                 </TableRow>
//               </TableHead>
//               <TableBody>
//                 <TableRow>
//                   {/* <TableCell>Velia.net Internetdienste GmbH</TableCell>
//                   <TableCell>Cloud Hosting Services</TableCell>
//                   <TableCell>Germany</TableCell> */}
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Contabo GmbH</TableCell>
//                   <TableCell>Cloud Hosting Services</TableCell>
//                   <TableCell>Germany</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Cytacom Solutions Ltd</TableCell>
//                   <TableCell>SMS Notification Service</TableCell>
//                   <TableCell>Cyprus</TableCell>
//                 </TableRow>
//                 <TableRow>
//                   <TableCell>Databasemart LLC</TableCell>
//                   <TableCell>Email Notification Service</TableCell>
//                   <TableCell>USA</TableCell>
//                 </TableRow>
//               </TableBody>
//             </Table>
//           </TableContainer>

//           <Typography paragraph>
//             We ensure that all third-party providers comply with GDPR and that
//             any data shared with them is handled securely and lawfully. All
//             third-party providers are contractually obligated to maintain the
//             confidentiality of your data.
//           </Typography>
//         </Box>

//         {/* Section 6: User Rights Under GDPR */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 6 Title")}
//           </Typography>
//           <Typography paragraph>
//             As a user, you have various rights regarding your personal data
//             under the GDPR. These rights include:
//           </Typography>

//           <List dense sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="1. Right to Access:"
//                 secondary="You have the right to request access to your personal data that we hold."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="2. Right to Rectification:"
//                 secondary="You can request correction of any inaccurate or incomplete data we have about you."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="3. Right to Erasure (Right to be Forgotten):"
//                 secondary="You can request that we delete your personal data under certain conditions."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="4. Right to Restriction of Processing:"
//                 secondary="You can ask us to restrict the processing of your data in certain situations."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="5. Right to Data Portability:"
//                 secondary="You can request a copy of your personal data in a structured, commonly used format, which you can transfer to another service."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="6. Right to Object:"
//                 secondary="You can object to our processing of your personal data for certain purposes, including data processing that is based on legitimate interests or is for direct marketing purposes."
//               />
//             </ListItem>
//           </List>

//           {/* Exercising Rights */}
//           <Typography
//             variant="subtitle1"
//             sx={{ fontWeight: "bold", mt: 2 }}
//           >
//             Exercising Your Rights:
//           </Typography>
//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText primary="• Currently, patients cannot directly modify or delete their personal data through the software." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• If you wish to exercise your rights (e.g., access, rectification, or deletion of your data), please contact us at [Insert Contact Information]. We will respond to your request within the timeframe specified by the GDPR." />
//             </ListItem>
//             <ListItem>
//               <ListItemText primary="• Additionally, we offer a GDPR Report feature within the software, allowing doctors or their secretaries to generate a PDF report detailing the data stored about a patient. This report can be provided to patients upon their request." />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 7: Data Retention */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 7 Title")}
//           </Typography>
//           <Typography paragraph>
//             We retain personal data as long as it is necessary to provide our
//             services and comply with legal obligations.
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Data Retention Period:"
//                 secondary="We do not currently have an automatic system in place for deleting or anonymizing data. The data is kept until the patient no longer requires appointments with the doctor."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Patient Data:"
//                 secondary="If patients request the deletion of their data, we will comply within the limits of applicable law."
//               />
//             </ListItem>
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             We are reviewing our data retention policy to ensure compliance with
//             GDPR guidelines and to implement automatic data deletion or
//             anonymization procedures where necessary.
//           </Typography>
//         </Box>

//         {/* Section 8: Legal Basis for Data Processing */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 8 Title")}
//           </Typography>
//           <Typography paragraph>
//             Under the GDPR, we must have a legal basis to collect and process
//             your personal data. Currently, the data is entered into the software
//             by the doctor or the doctor&apos;s secretary, and we are assessing
//             the most appropriate legal basis for processing this data. Possible
//             legal bases include:
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• User Consent:"
//                 secondary="If we require consent to collect data, we will implement a consent mechanism within the software."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Contractual Necessity:"
//                 secondary="The processing of personal data may be necessary to provide the appointment scheduling services that the patient has requested."
//               />
//             </ListItem>
//             <ListItem>
//               <ListItemText
//                 primary="• Legal Obligation:"
//                 secondary="We may be required to process certain data to comply with legal obligations related to healthcare."
//               />
//             </ListItem>
//           </List>

//           <Typography paragraph sx={{ mt: 2 }}>
//             We are evaluating the need for written consent from patients for
//             data processing and will implement such consent mechanisms in the
//             future if necessary.
//           </Typography>
//         </Box>

//         {/* Section 9: Cookies and Tracking Technologies */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 9 Title")}
//           </Typography>
//           <Typography paragraph>
//             The Appointment System does not use cookies or any tracking
//             technologies for user behavior analysis or advertising purposes. The
//             software is operated on a subscription model for doctors, and we do
//             not track or monitor users&apos; activities beyond the appointment
//             scheduling functionality.
//           </Typography>
//         </Box>

//         {/* Section 10: Data Transfers Outside the EU */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 10 Title")}
//           </Typography>
//           <Typography paragraph>
//             We ensure that all personal data is stored within the European Union
//             (EU). However, some of our third-party providers, such as
//             Databasemart LLC (USA), may process personal data outside the EU. We
//             ensure that all third-party service providers comply with GDPR
//             requirements by using appropriate safeguards, such as:
//           </Typography>

//           <List dense disablePadding sx={{ ml: 2 }}>
//             <ListItem>
//               <ListItemText
//                 primary="• Standard Contractual Clauses (SCCs):"
//                 secondary="We enter into contracts with our service providers to ensure that they comply with GDPR requirements for data transfers outside the EU."
//               />
//             </ListItem>
//           </List>
//         </Box>

//         {/* Section 11: GDPR Report Feature */}
//         <Box sx={{ mb: 4 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 11 Title")}
//           </Typography>
//           <Typography paragraph>
//             As part of our commitment to GDPR compliance and transparency, we
//             have implemented a GDPR Report feature within the Appointment
//             System. This feature enables doctors or their secretaries to
//             generate a detailed PDF report containing the personal data that is
//             stored for each patient. This report can be provided to the patient
//             upon request, ensuring that patients can access and review the data
//             we hold about them.
//           </Typography>
//         </Box>

//         {/* Section 12: Contact Information */}
//         <Box sx={{ mb: 2 }}>
//           <Typography
//             variant="h5"
//             component="h2"
//             gutterBottom
//             sx={{ fontWeight: "bold" }}
//           >
//             {t("GDPR Section 12 Title")}
//           </Typography>
//           <Typography paragraph>
//             For any questions, concerns, or requests regarding this Privacy
//             Policy or your personal data, please contact us at:
//           </Typography>

//           <Box sx={{ ml: 2 }}>
//             <Typography paragraph>
//               T.I Talostech Innovation Ltd
//               <br />
//               Email: support@ti-talostech.com
//               <br />
//             </Typography>
//           </Box>
//         </Box>

//         {/* Page Indicator */}
//         <Divider sx={{ my: 3 }} />
//         <Typography
//           variant="body2"
//           color="text.secondary"
//           align="center"
//         >
//           GDPR Privacy Policy | Last Updated:{" "}
//           {new Date().toLocaleDateString()}
//         </Typography>

//         {/* Action Buttons */}
//         <Stack
//           direction={isMobile ? "column" : "row"}
//           spacing={2}
//           sx={{ mt: 4 }}
//           justifyContent="center"
//         >
//           {/* Download PDF Button (Hidden in Modal View) */}
//           {!isModal && (
//             <Button
//               variant="outlined"
//               color="primary"
//               startIcon={<DownloadIcon />}
//               onClick={handleDownloadPDF}
//               sx={{ minWidth: 200 }}
//             >
//               {t("Download PDF")}
//             </Button>
//           )}
//           {/* Agree Button for Clients (Visible if GDPR Not Accepted) */}
//           {user?.user_role === "CLIENT" && !user?.gdpr_accepted && (
//             <Button
//               variant="contained"
//               color="primary"
//               startIcon={<CheckCircleOutlineIcon />}
//               onClick={isModal ? onAgree : handleAgree}
//               disabled={isSubmitting}
//               sx={{ minWidth: 200 }}
//             >
//               {isSubmitting
//                 ? t("Submitting...")
//                 : t("I Agree with GDPR Policy")}
//             </Button>
//           )}
//           {/* Disabled Button for Clients Who Have Accepted GDPR */}
//           {user?.user_role === "CLIENT" && user?.gdpr_accepted && (
//             <Button
//               variant="contained"
//               color="success"
//               disabled
//               sx={{ minWidth: 200 }}
//             >
//               {t("GDPR Accepted")}
//             </Button>
//           )}
//         </Stack>
//       </Paper>
//     </Container>
//   )
// }

// export default GDPRPolicy


// "use client";
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   Table,
//   TableBody,
//   TableCell,
//   TableContainer,
//   TableHead,
//   TableRow,
//   useMediaQuery,
//   Button,
//   Stack,
// } from "@mui/material";
// import { useTheme } from "@mui/material/styles";
// import DownloadIcon from "@mui/icons-material/Download";
// import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
// import { useStateContext } from "../context/ContextProvider";
// import { useTranslation } from "react-i18next";

// const GDPRPolicy = ({ onAgree, isModal = false, isSubmitting = false }) => {
//   const theme = useTheme();
//   const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
//   const { user } = useStateContext();
//   // const { t } = useTranslation();
//   const { t, i18n } = useTranslation();


//   // const handleDownloadPDF = () => {
//   //   const link = document.createElement("a");
//   //   link.href = "/gdpr-policy.pdf";
//   //   link.download = "General Data Protection Regulation.pdf";
//   //   document.body.appendChild(link);
//   //   link.click();
//   //   document.body.removeChild(link);
//   // };

//   const handleDownloadPDF = () => {
//   // current language from i18next (π.χ. "el", "el-GR", "en")
//   const lang = i18n.language || "en";

//   // default: English PDF
//   let pdfPath = "/gdpr-policy-en.pdf";
//   let fileName = "General Data Protection Regulation.pdf";

//   // if Greek selected -> use Greek PDF
//   if (lang.startsWith("el")) {
//     pdfPath = "/gdpr-policy-el.pdf";
//     fileName = "Πολιτική Απορρήτου GDPR.pdf";
//   }

//   const link = document.createElement("a");
//   link.href = pdfPath;
//   link.download = fileName;
//   document.body.appendChild(link);
//   link.click();
//   document.body.removeChild(link);
// };





//   const handleAgree = () => {
//     console.log("User agreed to GDPR Policy");
//   };

//   return (
//     <Container maxWidth="lg" sx={{ py: 4 }}>
//       <Paper elevation={3} sx={{ p: isMobile ? 2 : 4, borderRadius: 2 }}>
//         {/* Title */}
//         <Typography variant="h4" align="center" sx={{ mb: 3 }}>
//           {t("GDPR Title")}
//         </Typography>

//         {/* SECTION 1 */}
//         {/* <Box sx={{ mb: 4 }}> 
//           <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//             {t("GDPR Section 1 Title")}
//           </Typography>
//           <Typography paragraph>{t("GDPR Section 1 Intro P1")}</Typography>
//           <Typography paragraph>{t("GDPR Section 1 Intro P2")}</Typography>
//         </Box> */}
//             {/* SECTION 1 */}
//           <Box sx={{ mb: 4 }}>
//             <Typography
//               variant="h5"
//               sx={{ fontWeight: "bold", textAlign: "center" }}
//             >
//               {t("GDPR Section 1 Title")}
//             </Typography>

//             <Typography paragraph sx={{ textAlign: "left" }}>
//               {t("GDPR Section 1 Intro P1")}
//             </Typography>

//             <Typography paragraph sx={{ textAlign: "left" }}>
//               {t("GDPR Section 1 Intro P2")}
//             </Typography>
//           </Box>


//         {/* SECTION 2 */}
//         <Box sx={{ mb: 4 }}>
//           <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//             {t("GDPR Section 2 Title")}
//           </Typography>
//           <Typography paragraph>{t("GDPR Section 2 Intro")}</Typography>
//           {/* <Typography variant="subtitle1" sx={{ fontWeight: "bold" }}>
//             {t("GDPR Section 2 Required Title")}
//           </Typography> */}
//           <List dense>
//             <ListItem><ListItemText primary={t("Name")} /></ListItem>
//             <ListItem><ListItemText primary={t("Surname")} /></ListItem>
//             <ListItem><ListItemText primary={t("Email")} /></ListItem>
//             <ListItem><ListItemText primary={t("Phone_of_client")} /></ListItem>
//             <ListItem><ListItemText primary={t("Gender")} /></ListItem>
//             <ListItem><ListItemText primary={t("Date BirthDate")} /></ListItem>
//           </List>
//           {/* <Typography paragraph>{t("GDPR Section 2 EndText")}</Typography> */}
//         </Box>

// {/* SECTION 3 */}
// {/* <Box sx={{ mb: 4 }}>
//   <Typography
//     variant="h5"
//     sx={{ fontWeight: "bold", textAlign: "center" }}
//   >
//     {t("GDPR Section 3 Title")}
//   </Typography>

//   <Typography paragraph sx={{ textAlign: "left" }}>
//     {t("GDPR Section 3 Intro")}
//   </Typography>

//   <Typography paragraph sx={{ textAlign: "left" }}>
//     • <strong>{t("GDPR Purpose Scheduling")}</strong>: {t("GDPR Purpose Scheduling")}
//   </Typography>

//   <Typography paragraph sx={{ textAlign: "left" }}>
//     • <strong>{t("GDPR Purpose Notification")}</strong>: {t("GDPR Purpose Notification")}
//   </Typography>

//   <Typography paragraph sx={{ textAlign: "left" }}>
//     • <strong>{t("GDPR Purpose Analytics")}</strong>: {t("GDPR Purpose Analytics")}
//   </Typography>

//   <Typography paragraph sx={{ textAlign: "left" }}>
//     {t("GDPR Section 3 Outro")}
//   </Typography>
// </Box> */}


// {/* SECTION 3 */}
// <Box sx={{ mb: 4 }}>
//   <Typography
//     variant="h5"
//     sx={{ fontWeight: "bold", textAlign: "center" }}
//   >
//     {t("GDPR Section 3 Title")}
//   </Typography>

//   <Typography paragraph sx={{ textAlign: "left" }}>
//     {t("GDPR Section 3 Intro")}
//   </Typography>

//   <Box sx={{ textAlign: "left", pl: 2 }}>
//     <Typography paragraph>• {t("GDPR Purpose Scheduling")}</Typography>
//     <Typography paragraph>• {t("GDPR Purpose Notification")}</Typography>
//     <Typography paragraph>• {t("GDPR Purpose Analytics")}</Typography>
//   </Box>

//   <Typography paragraph sx={{ textAlign: "left" }}>
//     {t("GDPR Section 3 Outro")}
//   </Typography>
// </Box>






// {/* Section 4: Data Storage and Security Measures */}
// {/* SECTION 4 */}
// <Box sx={{ textAlign: "left", pl: 2, mb: 4 }}>

//   {/* Centered title */}
//   <Typography
//     variant="h5"
//     component="h2"
//     gutterBottom
//     sx={{ fontWeight: "bold", textAlign: "center" }}
//   >
//     {t("GDPR Section 4 Title")}
//   </Typography>

//   <Typography paragraph>
//     {t("GDPR Section 4 Intro")}
//   </Typography>

//   {/* Hosting Providers */}
//   <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
//     {t("GDPR Section 4 Hosting Title")}
//   </Typography>
//   <List dense disablePadding sx={{ ml: 2 }}>
//     <ListItem>
//       <ListItemText primary={t("GDPR Section 4 Hosting Contabo")} />
//     </ListItem>
//   </List>

//   <Typography paragraph sx={{ mt: 2 }}>
//     {t("GDPR Section 4 Providers Paragraph")}
//   </Typography>

//   {/* Data Storage */}
//   <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
//     {t("GDPR Section 4 Storage Title")}
//   </Typography>
//   <List dense disablePadding sx={{ ml: 2 }}>
//     <ListItem>
//       <ListItemText primary={t("GDPR Section 4 Storage1")} />
//     </ListItem>
//     <ListItem>
//       <ListItemText primary={t("GDPR Section 4 Storage2")} />
//     </ListItem>
//     <ListItem>
//       <ListItemText primary={t("GDPR Section 4 Storage3")} />
//     </ListItem>
//   </List>

//   {/* Security Measures */}
//   <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2 }}>
//     {t("GDPR Section 4 Security Title")}
//   </Typography>
//   <List dense disablePadding sx={{ ml: 2 }}>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 4 Security1 Primary")}
//         secondary={t("GDPR Section 4 Security1 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 4 Security2 Primary")}
//         secondary={t("GDPR Section 4 Security2 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 4 Security3 Primary")}
//         secondary={t("GDPR Section 4 Security3 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 4 Security4 Primary")}
//         secondary={t("GDPR Section 4 Security4 Secondary")}
//       />
//     </ListItem>
//   </List>

// </Box>


// {/* Section 5: Sharing Personal Data with Third Parties */}
// {/* <Box sx={{ mb: 4 }}> */}


//   <Box sx={{ textAlign: "left", pl: 2, mb: 4 }}>
//   <Typography
//     variant="h5"
//     component="h2"
//     gutterBottom
//     // sx={{ fontWeight: "bold" }}
//     sx={{ fontWeight: "bold", textAlign: "center" }}
//   >
//     {t("GDPR Section 5 Title")}
//   </Typography>

//   <Typography paragraph>
//     {t("GDPR Section 5 Intro")}
//   </Typography>

//   {/* Third-Party Providers Table */}
//   <TableContainer component={Paper} sx={{ mb: 2 }}>
//     <Table size={isMobile ? "small" : "medium"}>
//       <TableHead>
//         <TableRow>
//           <TableCell>
//             <strong>{t("GDPR Section 5 Table ProviderHeader")}</strong>
//           </TableCell>
//           <TableCell>
//             <strong>{t("GDPR Section 5 Table PurposeHeader")}</strong>
//           </TableCell>
//           <TableCell>
//             <strong>{t("GDPR Section 5 Table LocationHeader")}</strong>
//           </TableCell>
//         </TableRow>
//       </TableHead>
//       <TableBody>
//         {/* Example (commented out) */}
//         {/* <TableRow>
//           <TableCell>Velia.net Internetdienste GmbH</TableCell>
//           <TableCell>{t("GDPR Section 5 Purpose Hosting")}</TableCell>
//           <TableCell>{t("GDPR Section 5 Location Germany")}</TableCell>
//         </TableRow> */}
//         <TableRow>
//           <TableCell>Contabo GmbH</TableCell>
//           <TableCell>{t("GDPR Section 5 Purpose Hosting")}</TableCell>
//           <TableCell>{t("GDPR Section 5 Location Germany")}</TableCell>
//         </TableRow>
//         <TableRow>
//           <TableCell>Cytacom Solutions Ltd</TableCell>
//           <TableCell>{t("GDPR Section 5 Purpose SMS")}</TableCell>
//           <TableCell>{t("GDPR Section 5 Location Cyprus")}</TableCell>
//         </TableRow>
//         <TableRow>
//           <TableCell>Databasemart LLC</TableCell>
//           <TableCell>{t("GDPR Section 5 Purpose Email")}</TableCell>
//           <TableCell>{t("GDPR Section 5 Location USA")}</TableCell>
//         </TableRow>
//       </TableBody>
//     </Table>
//   </TableContainer>

//   <Typography paragraph>
//     {t("GDPR Section 5 EndText")}
//   </Typography>
// </Box>


// {/* Section 6: User Rights Under GDPR */}
// <Box sx={{ mb: 4 }}>
//   <Typography
//     variant="h5"
//     component="h2"
//     gutterBottom
//     sx={{ fontWeight: "bold" }}
//   >
//     {t("GDPR Section 6 Title")}
//   </Typography>

//   <Typography paragraph>
//     {t("GDPR Section 6 Intro")}
//   </Typography>

//   <List dense sx={{ ml: 2 }}>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 6 Right1 Primary")}
//         secondary={t("GDPR Section 6 Right1 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 6 Right2 Primary")}
//         secondary={t("GDPR Section 6 Right2 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 6 Right3 Primary")}
//         secondary={t("GDPR Section 6 Right3 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 6 Right4 Primary")}
//         secondary={t("GDPR Section 6 Right4 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 6 Right5 Primary")}
//         secondary={t("GDPR Section 6 Right5 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 6 Right6 Primary")}
//         secondary={t("GDPR Section 6 Right6 Secondary")}
//       />
//     </ListItem>
//   </List>

//   {/* Exercising Rights */}
//   <Typography variant="subtitle1" sx={{ fontWeight: "bold", mt: 2, textAlign: "center" }}>
//   {t("GDPR Section 6 Exercising Title")}
// </Typography>

 
//   <List dense disablePadding sx={{ ml: 2 }}>
//     <ListItem>
//       <ListItemText primary={t("GDPR Section 6 Exercising Bullet1")} />
//     </ListItem>
//     <ListItem>
//       <ListItemText primary={t("GDPR Section 6 Exercising Bullet2")} />
//     </ListItem>
//     <ListItem>
//       <ListItemText primary={t("GDPR Section 6 Exercising Bullet3")} />
//     </ListItem>
//   </List>
// </Box>








//           {/* Section 7: Data Retention */}
//        {/* Section 7: Data Retention */}
// <Box sx={{ textAlign: "left", pl: 2, mb: 4 }}>
//   <Typography
//     variant="h5"
//     component="h2"
//     gutterBottom
//     sx={{ fontWeight: "bold", textAlign: "center" }}
//   >
//     {t("GDPR Section 7 Title")}
//   </Typography>

//   <Typography paragraph>
//     We retain personal data as long as it is necessary to provide our
//     services and comply with legal obligations.
//   </Typography>

//   <List dense disablePadding sx={{ ml: 2 }}>
//     <ListItem>
//       <ListItemText
//         primary="• Data Retention Period:"
//         secondary="We do not currently have an automatic system in place for deleting or anonymizing data. The data is kept until the patient no longer requires appointments with the doctor."
//       />
//     </ListItem>

//     <ListItem>
//       <ListItemText
//         primary="• Patient Data:"
//         secondary="If patients request the deletion of their data, we will comply within the limits of applicable law."
//       />
//     </ListItem>
//   </List>

//   <Typography paragraph sx={{ mt: 2 }}>
//     We are reviewing our data retention policy to ensure compliance with
//     GDPR guidelines and to implement automatic data deletion or
//     anonymization procedures where necessary.
//   </Typography>
// </Box>


// {/* Section 8: Legal Basis for Data Processing */}


// <Box sx={{ mb: 4 }}>
//   <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//     {t("GDPR Section 8 Title")}
//   </Typography>

//   <Typography paragraph>{t("GDPR Section 8 Intro")}</Typography>

//   <List dense disablePadding sx={{ ml: 2 }}>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 8 Legal1 Primary")}
//         secondary={t("GDPR Section 8 Legal1 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 8 Legal2 Primary")}
//         secondary={t("GDPR Section 8 Legal2 Secondary")}
//       />
//     </ListItem>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 8 Legal3 Primary")}
//         secondary={t("GDPR Section 8 Legal3 Secondary")}
//       />
//     </ListItem>
//   </List>

//   <Typography paragraph sx={{ mt: 2 }}>
//     {t("GDPR Section 8 EndText")}
//   </Typography>
// </Box>

// {/* Section 9: Cookies and Tracking Technologies */}
// <Box sx={{ mb: 4 }}>
  
//   <Typography variant="h5" component="h2" gutterBottom sx={{ fontWeight: "bold" }}>
//     {t("GDPR Section 9 Title")}
//   </Typography>
// <Box sx={{ textAlign: "left", pl: 2, mb: 4 }}>
//   <Typography paragraph>{t("GDPR Section 9 Intro")}</Typography>
//   </Box>
// </Box>

// {/* Section 10: Data Transfers Outside the EU */}
// <Box sx={{ mb: 4 }}>
//   <Typography
//     variant="h5"
//     component="h2"
//     gutterBottom
//     sx={{ fontWeight: "bold" }}
//   >
//     {t("GDPR Section 10 Title")}
//   </Typography>
// <Box sx={{ textAlign: "left", pl: 2, mb: 4 }}>
//   <Typography paragraph>
//     {t("GDPR Section 10 Intro")}
    
//   </Typography>
// </Box>
//   <List dense disablePadding sx={{ ml: 2 }}>
//     <ListItem>
//       <ListItemText
//         primary={t("GDPR Section 10 Safeguard1 Primary")}
//         secondary={t("GDPR Section 10 Safeguard1 Secondary")}
//       />
//     </ListItem>
//   </List>
// </Box>

// {/* Section 11: GDPR Report Feature */}
// <Box sx={{ mb: 4 }}>
//   <Typography
//     variant="h5"
//     component="h2"
//     gutterBottom
//     sx={{ fontWeight: "bold" }}
//   >
//     {t("GDPR Section 11 Title")}
//   </Typography>
// <Box sx={{ textAlign: "left", pl: 2, mb: 4 }}>
//   <Typography paragraph>
//     {t("GDPR Section 11 Intro")}
//   </Typography>
//   </Box>
// </Box>




//         {/* SECTION 12 - Contact */}
//         <Box sx={{ mb: 2 }}>
//           <Typography variant="h5" sx={{ fontWeight: "bold" }}>
//             {t("GDPR Section 12 Title")}
//           </Typography>
//           {/* <Typography paragraph>{t("GDPR Section 12 Intro")}</Typography> */}
//           <Typography paragraph>
//             T.I Talostech Innovation Ltd <br />
//             Email: support@ti-talostech.com
//           </Typography>
//         </Box>

//         <Divider sx={{ my: 3 }} />
//         <Typography align="center">
//           GDPR Privacy Policy | Last Updated: {new Date().toLocaleDateString()}
//         </Typography>

//         <Stack direction={isMobile ? "column" : "row"} spacing={2} justifyContent="center" sx={{ mt: 4 }}>
//           {!isModal && (
//             <Button variant="outlined" startIcon={<DownloadIcon />} onClick={handleDownloadPDF}>
//               {t("Download PDF")}
//             </Button>
//           )}

//           {user?.user_role === "CLIENT" && !user?.gdpr_accepted && (
//             <Button variant="contained" startIcon={<CheckCircleOutlineIcon />} onClick={isModal ? onAgree : handleAgree} disabled={isSubmitting}>
//               {isSubmitting ? t("Submitting...") : t("I Agree with GDPR Policy")}
//             </Button>
//           )}

//           {user?.user_role === "CLIENT" && user?.gdpr_accepted && (
//             <Button variant="contained" color="success" disabled>
//               {t("GDPR Accepted")}
//             </Button>
//           )}
//         </Stack>
//       </Paper>
//     </Container>
//   );
// };

// export default GDPRPolicy;


// import React, { useState } from "react";
// import {
//   Box,
//   Container,
//   Typography,
//   Paper,
//   List,
//   ListItem,
//   ListItemText,
//   Divider,
//   Button,
//   // Stack,
//   Checkbox,
//   FormControlLabel,
// } from "@mui/material";
// import { useTranslation } from "react-i18next";
// import GDPRPolicyLink from "../components/GDPRPolicyLink";

// const GDPRPolicyScreen = ({
//   onAgree,
//   isModal = false,
//   isSubmitting = false,
// }) => {
//   const { t } = useTranslation();
//   const [confirmed, setConfirmed] = useState(false);

//   const handleAgreeClick = () => {
//     if (!confirmed || !onAgree) return;
//     onAgree();
//   };

//   return (
//     <Container maxWidth="md">
//       <Paper elevation={0} sx={{ p: 3 }}>
//         {/* Title */}
//         <Typography variant="h5" gutterBottom>
//           {t("GDPR Title")}
//         </Typography>

//         {/* Section 1 – Intro */}
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 1 Intro P1")}
//         </Typography>
//         <Typography variant="body2" paragraph sx={{ mb: 3 }}>
//           {t("GDPR Section 1 Intro P2")}
//         </Typography>

//         {/* Link to full policy (your link component) */}
//         <Box sx={{ mb: 3 }}>
//           <GDPRPolicyLink />
//         </Box>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 2 – Personal Data We Collect */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 2 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 2 Intro")}
//         </Typography>

//         <List dense>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Required Personal Data")}
//               primaryTypographyProps={{ variant: "subtitle2" }}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Field Name")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Field Surname")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Field Email")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Field Phone")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Field Gender Optional")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Field DOB Optional")} />
//           </ListItem>
//         </List>

//         <Typography variant="body2" paragraph sx={{ mt: 1 }}>
//           {t("GDPR Section 2 Outro")}
//         </Typography>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 3 – Purpose of Data Collection */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 3 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 3 Intro")}
//         </Typography>
//         <List dense>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 3 Purpose1 Label")}
//               secondary={t("GDPR Section 3 Purpose1 Text")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 3 Purpose2 Label")}
//               secondary={t("GDPR Section 3 Purpose2 Text")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 3 Purpose3 Label")}
//               secondary={t("GDPR Section 3 Purpose3 Text")}
//             />
//           </ListItem>
//         </List>
//         <Typography variant="body2" paragraph sx={{ mt: 1 }}>
//           {t("GDPR Section 3 EndText")}
//         </Typography>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 4 – Storage & Security */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 4 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 4 Intro")}
//         </Typography>

//         <Typography variant="subtitle2" gutterBottom>
//           {t("GDPR Section 4 Hosting Title")}
//         </Typography>
//         <List dense>
//           <ListItem>
//             <ListItemText primary={t("GDPR Section 4 Hosting Contabo")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Section 4 Hosting Velia")} />
//           </ListItem>
//         </List>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 4 Providers Paragraph")}
//         </Typography>

//         <Typography variant="subtitle2" gutterBottom sx={{ mt: 1 }}>
//           {t("GDPR Section 4 Storage Title")}
//         </Typography>
//         <List dense>
//           <ListItem>
//             <ListItemText primary={t("GDPR Section 4 Storage1")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Section 4 Storage2")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Section 4 Storage3")} />
//           </ListItem>
//         </List>

//         <Typography variant="subtitle2" gutterBottom sx={{ mt: 1 }}>
//           {t("GDPR Section 4 Security Title")}
//         </Typography>
//         <List dense>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 4 Security1 Primary")}
//               secondary={t("GDPR Section 4 Security1 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 4 Security2 Primary")}
//               secondary={t("GDPR Section 4 Security2 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 4 Security3 Primary")}
//               secondary={t("GDPR Section 4 Security3 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 4 Security4 Primary")}
//               secondary={t("GDPR Section 4 Security4 Secondary")}
//             />
//           </ListItem>
//         </List>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 5 – Third Parties (short form using your table text) */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 5 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 5 Intro")}
//         </Typography>

//         <List dense>
//           <ListItem>
//             <ListItemText
//               primary={`${t("GDPR Section 5 Purpose Hosting")} – ${t(
//                 "GDPR Section 5 Location Germany"
//               )}`}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={`${t("GDPR Section 5 Purpose SMS")} – ${t(
//                 "GDPR Section 5 Location Cyprus"
//               )}`}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={`${t("GDPR Section 5 Purpose Email")} – ${t(
//                 "GDPR Section 5 Location USA"
//               )}`}
//             />
//           </ListItem>
//         </List>

//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 5 EndText")}
//         </Typography>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 6 – Rights */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 6 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 6 Intro")}
//         </Typography>

//         <List dense>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Right1 Primary")}
//               secondary={t("GDPR Section 6 Right1 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Right2 Primary")}
//               secondary={t("GDPR Section 6 Right2 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Right3 Primary")}
//               secondary={t("GDPR Section 6 Right3 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Right4 Primary")}
//               secondary={t("GDPR Section 6 Right4 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Right5 Primary")}
//               secondary={t("GDPR Section 6 Right5 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Right6 Primary")}
//               secondary={t("GDPR Section 6 Right6 Secondary")}
//             />
//           </ListItem>
//         </List>

//         <Typography variant="subtitle2" gutterBottom sx={{ mt: 1 }}>
//           {t("GDPR Section 6 Exercising Title")}
//         </Typography>
//         <List dense>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Exercising Bullet1")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Exercising Bullet2")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 6 Exercising Bullet3")}
//             />
//           </ListItem>
//         </List>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 7 – Retention (short) */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 7 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 7 Intro")}
//         </Typography>
//         <List dense>
//           <ListItem>
//             <ListItemText primary={t("GDPR Retention NoAuto")} />
//           </ListItem>
//           <ListItem>
//             <ListItemText primary={t("GDPR Retention Request")} />
//           </ListItem>
//         </List>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Retention Review")}
//         </Typography>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 8 – Legal Basis */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 8 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 8 Intro")}
//         </Typography>
//         <List dense>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 8 Legal1 Primary")}
//               secondary={t("GDPR Section 8 Legal1 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 8 Legal2 Primary")}
//               secondary={t("GDPR Section 8 Legal2 Secondary")}
//             />
//           </ListItem>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 8 Legal3 Primary")}
//               secondary={t("GDPR Section 8 Legal3 Secondary")}
//             />
//           </ListItem>
//         </List>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 8 EndText")}
//         </Typography>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 9 – Cookies */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 9 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 9 Intro")}
//         </Typography>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 10 – Transfers */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 10 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 10 Intro")}
//         </Typography>
//         <List dense>
//           <ListItem>
//             <ListItemText
//               primary={t("GDPR Section 10 Safeguard1 Primary")}
//               secondary={t("GDPR Section 10 Safeguard1 Secondary")}
//             />
//           </ListItem>
//         </List>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 11 – GDPR Report */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 11 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Section 11 Intro")}
//         </Typography>

//         <Divider sx={{ my: 2 }} />

//         {/* Section 12 – Contact */}
//         <Typography variant="h6" gutterBottom>
//           {t("GDPR Section 12 Title")}
//         </Typography>
//         <Typography variant="body2" paragraph>
//           {t("GDPR Contact")}
//         </Typography>

//         {/* Checkbox + YES button ONLY when used as modal */}
//         {isModal && (
//           <Box sx={{ mt: 4 }}>
//             <FormControlLabel
//               control={
//                 <Checkbox
//                   checked={confirmed}
//                   onChange={(e) => setConfirmed(e.target.checked)}
//                   size="small"
//                 />
//               }
//               label={t("Agreed to GDPR Policy?")}
//             />
//             <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
//               <Button
//                 variant="contained"
//                 color="primary"
//                 onClick={handleAgreeClick}
//                 disabled={!confirmed || isSubmitting}
//               >
//                 {t("Yes")}
//               </Button>
//             </Box>
//           </Box>
//         )}
//       </Paper>
//     </Container>
//   );
// };

// export default GDPRPolicyScreen;


// src/screens/GdprPolicyScreen.jsx
"use client";

import React, { useState } from "react";
import {
  Box,
  Container,
  Typography,
  Paper,
  List,
  ListItem,
  ListItemText,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  useMediaQuery,
  Button,
  Checkbox,
  FormControlLabel,
  Link,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { useTranslation } from "react-i18next";

/**
 * GDPR Policy Screen
 * Can be used:
 *  - as a full page: <GDPRPOLICY />
 *  - inside a modal: <GDPRPOLICY onAgree={...} isModal isSubmitting={...} />
 */
const GDPRPolicyScreen = ({
  onAgree = () => {},
  isModal = false,
  isSubmitting = false,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const { t } = useTranslation();

  const [gdprConfirmed, setGdprConfirmed] = useState(false);

  return (
    <Container
      maxWidth="md"
      sx={{
        py: isModal ? 0 : 4,
      }}
    >
      <Paper
        elevation={isModal ? 0 : 3}
        sx={{
          p: isMobile ? 2 : 4,
        }}
      >
        {/* Title */}
        <Typography
          variant={isMobile ? "h6" : "h5"}
          gutterBottom
          sx={{ fontWeight: 600 }}
        >
          {t("GDPR Title")}
        </Typography>

        {/* Intro Section */}
        <Typography variant="body2" paragraph sx={{ mt: 1 }}>
          {t("GDPR Section 1 Intro P1")}
        </Typography>
        <Typography variant="body2" paragraph>
          {t("GDPR Section 1 Intro P2")}
        </Typography>

        {/* Link to full policy (scrolls to details section) */}
        <Box sx={{ mt: 2, mb: 3 }}>
          <Link href="#full-gdpr" underline="hover">
            {t("GDPR Policy") || "GDPR Policy"}
          </Link>
        </Box>

        <Divider sx={{ my: 2 }} />

        {/* Full GDPR details */}
        <Box id="full-gdpr">
          {/* Section 2 – Personal Data We Collect */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 2 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 2 Intro")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary={t("GDPR Field Name")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Field Surname")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Field Email")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Field Phone")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Field Gender Optional")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Field DOB Optional")} />
            </ListItem>
          </List>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 2 Outro")}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Section 3 – Purpose of Data Collection */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 3 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 3 Intro")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 3 Purpose1 Label")}
                secondary={t("GDPR Section 3 Purpose1 Text")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 3 Purpose2 Label")}
                secondary={t("GDPR Section 3 Purpose2 Text")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 3 Purpose3 Label")}
                secondary={t("GDPR Section 3 Purpose3 Text")}
              />
            </ListItem>
          </List>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 3 EndText")}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Section 4 – Data Storage and Security */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 4 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 4 Intro")}
          </Typography>
          <Typography variant="subtitle2" sx={{ mt: 1 }}>
            {t("GDPR Section 4 Hosting Title")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary={t("GDPR Section 4 Hosting Contabo")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Section 4 Hosting Velia")} />
            </ListItem>
          </List>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 4 Providers Paragraph")}
          </Typography>

          <Typography variant="subtitle2" sx={{ mt: 1 }}>
            {t("GDPR Section 4 Storage Title")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary={t("GDPR Section 4 Storage1")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Section 4 Storage2")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Section 4 Storage3")} />
            </ListItem>
          </List>

          <Typography variant="subtitle2" sx={{ mt: 1 }}>
            {t("GDPR Section 4 Security Title")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 4 Security1 Primary")}
                secondary={t("GDPR Section 4 Security1 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 4 Security2 Primary")}
                secondary={t("GDPR Section 4 Security2 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 4 Security3 Primary")}
                secondary={t("GDPR Section 4 Security3 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 4 Security4 Primary")}
                secondary={t("GDPR Section 4 Security4 Secondary")}
              />
            </ListItem>
          </List>

          <Divider sx={{ my: 2 }} />

          {/* Section 5 – Sharing with Third Parties (table) */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 5 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 5 Intro")}
          </Typography>

          <TableContainer component={Box} sx={{ mb: 2 }}>
            <Table size="small">
              <TableHead>
                <TableRow>
                  <TableCell>{t("GDPR Section 5 Table ProviderHeader")}</TableCell>
                  <TableCell>{t("GDPR Section 5 Table PurposeHeader")}</TableCell>
                  <TableCell>{t("GDPR Section 5 Table LocationHeader")}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                <TableRow>
                  <TableCell>Contabo VPS</TableCell>
                  <TableCell>{t("GDPR Section 5 Purpose Hosting")}</TableCell>
                  <TableCell>{t("GDPR Section 5 Location Germany")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Cytacom Solutions Ltd</TableCell>
                  <TableCell>{t("GDPR Section 5 Purpose SMS")}</TableCell>
                  <TableCell>{t("GDPR Section 5 Location Cyprus")}</TableCell>
                </TableRow>
                <TableRow>
                  <TableCell>Databasemart LLC</TableCell>
                  <TableCell>{t("GDPR Section 5 Purpose Email")}</TableCell>
                  <TableCell>{t("GDPR Section 5 Location USA")}</TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </TableContainer>

          <Typography variant="body2" paragraph>
            {t("GDPR Section 5 EndText")}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Section 6 – User Rights */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 6 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 6 Intro")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Right1 Primary")}
                secondary={t("GDPR Section 6 Right1 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Right2 Primary")}
                secondary={t("GDPR Section 6 Right2 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Right3 Primary")}
                secondary={t("GDPR Section 6 Right3 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Right4 Primary")}
                secondary={t("GDPR Section 6 Right4 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Right5 Primary")}
                secondary={t("GDPR Section 6 Right5 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Right6 Primary")}
                secondary={t("GDPR Section 6 Right6 Secondary")}
              />
            </ListItem>
          </List>
          <Typography variant="subtitle2" sx={{ mt: 1 }}>
            {t("GDPR Section 6 Exercising Title")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Exercising Bullet1")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Exercising Bullet2")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 6 Exercising Bullet3")}
              />
            </ListItem>
          </List>

          <Divider sx={{ my: 2 }} />

          {/* Section 7 – Data Retention */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 7 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 7 Intro")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText primary={t("GDPR Retention NoAuto")} />
            </ListItem>
            <ListItem>
              <ListItemText primary={t("GDPR Retention Request")} />
            </ListItem>
          </List>
          <Typography variant="body2" paragraph>
            {t("GDPR Retention Review")}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Section 8 – Legal Basis */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 8 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 8 Intro")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 8 Legal1 Primary")}
                secondary={t("GDPR Section 8 Legal1 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 8 Legal2 Primary")}
                secondary={t("GDPR Section 8 Legal2 Secondary")}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 8 Legal3 Primary")}
                secondary={t("GDPR Section 8 Legal3 Secondary")}
              />
            </ListItem>
          </List>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 8 EndText")}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Section 9 – Cookies */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 9 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 9 Intro")}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Section 10 – Data Transfers */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 10 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 10 Intro")}
          </Typography>
          <List dense>
            <ListItem>
              <ListItemText
                primary={t("GDPR Section 10 Safeguard1 Primary")}
                secondary={t("GDPR Section 10 Safeguard1 Secondary")}
              />
            </ListItem>
          </List>

          <Divider sx={{ my: 2 }} />

          {/* Section 11 – GDPR Report */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 11 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Section 11 Intro")}
          </Typography>

          <Divider sx={{ my: 2 }} />

          {/* Section 12 – Contact */}
          <Typography variant="h6" sx={{ mt: 2, mb: 1 }}>
            {t("GDPR Section 12 Title")}
          </Typography>
          <Typography variant="body2" paragraph>
            {t("GDPR Contact")}
          </Typography>
        </Box>

        {/* Agree Section with checkbox + button */}
        <Divider sx={{ my: 3 }} />

        <Typography variant="body2" sx={{ mb: 1 }}>
          {t("Agreed to GDPR Policy?") || "AGREED TO GDPR POLICY?"}
        </Typography>

        <FormControlLabel
          control={
            <Checkbox
              checked={gdprConfirmed}
              onChange={(e) => setGdprConfirmed(e.target.checked)}
              size="small"
            />
          }
          label={t("I agree to the GDPR Privacy Policy") || "I agree to the GDPR Privacy Policy"}
          sx={{ mb: 2 }}
        />

        <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 1 }}>
          <Button
            variant="contained"
            color="primary"
            onClick={onAgree}
            disabled={!gdprConfirmed || isSubmitting}
          >
            {isSubmitting ? t("Processing...") || "Processing..." : t("Yes") || "YES"}
          </Button>
        </Box>
      </Paper>
    </Container>
  );
};

export default GDPRPolicyScreen;

